import MaterialDialogActions, {
    DialogActionsProps,
} from '@mui/material/DialogActions';

export function DialogActions(props: DialogActionsProps) {
    return (
        <MaterialDialogActions
            data-testid={'DialogActions-container'}
            {...props}
        />
    );
}

export default DialogActions;
